// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BuyAPart_wrap__Zl34x {
  padding: 28px 30px;
  width: 100%;
  border-radius: 40px;
  transition: 0.35s ease;
  height: 100%;
  cursor: pointer;
  background-color: #eaeaea;
}
.BuyAPart_wrap__linker__hf7-R {
  max-width: 353px;
}
.BuyAPart_wrap__up__pJz42 {
  display: flex;
  column-gap: 15px;
  align-items: center;
  justify-content: space-between;
}
.BuyAPart_wrap__up__link__2b28j {
  border: 2px solid #000;
  transition: 0.35s ease;
}
.BuyAPart_wrap__up__icon__wrap__a3opU {
  background-color: #fff;
  padding: 17px;
  border-radius: 100%;
}
.BuyAPart_wrap__up__icon__wrap__a3opU svg {
  transition: 0.35s ease;
  height: 33px;
  width: 33px;
}
.BuyAPart_wrap__down__jWeyx {
  margin-top: 40px;
  display: flex;
}
.BuyAPart_wrap__down__under__\\+1P8\\+ {
  margin-top: 15px;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 31px; /* 155% */
  letter-spacing: -0.4px;
}
.BuyAPart_wrap__Zl34x .BuyAPart_arrow__D20mt svg {
  height: 50px;
  width: 50px;
  padding-bottom: 0;
  margin-left: 20px;
  transition: 0.35s ease;
  color: #000;
  margin-bottom: 15px;
}
.BuyAPart_wrap__Zl34x:hover .BuyAPart_wrap__up__link__2b28j, .BuyAPart_wrap__Zl34x:active .BuyAPart_wrap__up__link__2b28j {
  margin-bottom: 10px;
  background-color: transparent;
  color: #000;
}

@media (max-width: 1280px) {
  .BuyAPart_wrap__linker__hf7-R {
    max-width: 100%;
  }
}
@media ((max-width: 1024px)) {
  .BuyAPart_wrap__linker__hf7-R {
    max-width: 100%;
  }
  .BuyAPart_wrap__Zl34x:hover .BuyAPart_wrap__up__link__2b28j, .BuyAPart_wrap__Zl34x:active .BuyAPart_wrap__up__link__2b28j {
    margin-bottom: 0px;
  }
}
@media ((max-width: 728px)) {
  .BuyAPart_wrap__up__icon__wrap__a3opU {
    padding: 10px;
  }
  .BuyAPart_wrap__up__icon__wrap__a3opU svg {
    width: 25px;
    height: 25px;
  }
  .BuyAPart_wrap__down__jWeyx {
    margin-top: 1rem;
  }
  .BuyAPart_wrap__down__under__\\+1P8\\+ {
    font-size: 16px;
    margin-top: 0;
  }
  .BuyAPart_wrap__linker__hf7-R {
    height: 230px;
  }
  .BuyAPart_wrap__linker__hf7-R .BuyAPart_wrap__Zl34x {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/mainPage/buyAPart/BuyAPart.module.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBCFI;EDGJ,YAAA;EACA,eAAA;EACA,yBAAA;AADD;AAGC;EACC,gBAAA;AADF;AAIC;EACC,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;AAFF;AAIE;EACC,sBAAA;EACA,sBCnBE;ADiBL;AAIE;EACC,sBAAA;EACA,aAAA;EACA,mBAAA;AAFH;AAIG;EACC,sBC3BC;ED4BD,YAAA;EACA,WAAA;AAFJ;AAOC;EACC,gBAAA;EACA,aAAA;AALF;AAOE;EACC,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,sBAAA;AALH;AASC;EACC,YAAA;EACA,WAAA;EAEA,iBAAA;EACA,iBAAA;EACA,sBCtDG;EDuDH,WCxDK;EDyDL,mBAAA;AAPF;AAYE;EACC,mBAAA;EACA,6BAAA;EACA,WCjEI;ADuDP;;AAgBA;EACC;IACC,eAAA;EAbA;AACF;AAgBA;EAEE;IACC,eAAA;EAfD;EAoBC;IACC,kBAAA;EAlBF;AACF;AAuBA;EAGG;IACC,aAAA;EAvBF;EAwBE;IACC,WAAA;IACA,YAAA;EAtBH;EA2BA;IACC,gBAAA;EAzBD;EA0BC;IACC,eAAA;IACA,aAAA;EAxBF;EA6BD;IACC,aAAA;EA3BA;EA6BA;IACC,aAAA;IACA,sBAAA;IACA,8BAAA;EA3BD;AACF","sourcesContent":["@import '../../../variables';\n\n.wrap {\n\tpadding: 28px 30px;\n\twidth: 100%;\n\tborder-radius: $br40;\n\ttransition: $tr;\n\theight: 100%;\n\tcursor: pointer;\n\tbackground-color: #eaeaea;\n\n\t&__linker {\n\t\tmax-width: 353px;\n\t}\n\n\t&__up {\n\t\tdisplay: flex;\n\t\tcolumn-gap: 15px;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\n\t\t&__link {\n\t\t\tborder: 2px solid #000;\n\t\t\ttransition: $tr;\n\t\t}\n\t\t&__icon__wrap {\n\t\t\tbackground-color: #fff;\n\t\t\tpadding: 17px;\n\t\t\tborder-radius: 100%;\n\n\t\t\tsvg {\n\t\t\t\ttransition: $tr;\n\t\t\t\theight: 33px;\n\t\t\t\twidth: 33px;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__down {\n\t\tmargin-top: 40px;\n\t\tdisplay: flex;\n\n\t\t&__under {\n\t\t\tmargin-top: 15px;\n\t\t\tfont-size: 20px;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 31px; /* 155% */\n\t\t\tletter-spacing: -0.4px;\n\t\t}\n\t}\n\n\t.arrow svg {\n\t\theight: 50px;\n\t\twidth: 50px;\n\t\tmargin-bottom: -4px;\n\t\tpadding-bottom: 0;\n\t\tmargin-left: 20px;\n\t\ttransition: $tr;\n\t\tcolor: $dark;\n\t\tmargin-bottom: 15px;\n\t}\n\n\t&:hover,\n\t&:active {\n\t\t.wrap__up__link {\n\t\t\tmargin-bottom: 10px;\n\t\t\tbackground-color: transparent;\n\t\t\tcolor: $dark;\n\t\t}\n\t}\n}\n\n\n@media (max-width: 1280px) {\n\t.wrap__linker {\n\t\tmax-width: 100%;\n\t}\n}\n\n@media ((max-width: 1024px)) {\n\t.wrap {\n\t\t&__linker {\n\t\t\tmax-width: 100%;\n\t\t}\n\n\t\t&:hover,\n\t\t&:active {\n\t\t\t.wrap__up__link {\n\t\t\t\tmargin-bottom: 0px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media ((max-width: 728px)) {\n\t.wrap {\n\t\t&__up {\n\t\t\t&__icon__wrap {\n\t\t\t\tpadding: 10px;\n\t\t\t\tsvg {\n\t\t\t\t\twidth: 25px;\n\t\t\t\t\theight: 25px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&__down {\n\t\t\tmargin-top: 1rem;\n\t\t\t&__under {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t.wrap__linker {\n\t\theight: 230px;\n\n\t\t.wrap {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-between;\n\t\t}\n\t}\n}\n","$accent: #ff6f19;\n$grey: #eaeaea;\n$w: #fff;\n$dark: #000;\n$tr: 0.35s ease;\n$br40: 40px;\n$Jost: 'Jost-Regular';\n$Jost300: 'Jost-Light';\n$Jost500: 'Jost-Medium';\n$Jost600: 'Jost-SemiBold';\n$Jost700: 'Jost-Bold';\n$Jost800: 'Jost-ExtraBold';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BuyAPart_wrap__Zl34x`,
	"wrap__linker": `BuyAPart_wrap__linker__hf7-R`,
	"wrap__up": `BuyAPart_wrap__up__pJz42`,
	"wrap__up__link": `BuyAPart_wrap__up__link__2b28j`,
	"wrap__up__icon__wrap": `BuyAPart_wrap__up__icon__wrap__a3opU`,
	"wrap__down": `BuyAPart_wrap__down__jWeyx`,
	"wrap__down__under": `BuyAPart_wrap__down__under__+1P8+`,
	"arrow": `BuyAPart_arrow__D20mt`
};
export default ___CSS_LOADER_EXPORT___;
